import { reducers } from './reducers';
import { getFrameIdFromWindowContext } from './gridEditorUtils';
import { persistentReducedStream } from '@ardoq/rxbeach';
import { GridEditorState } from './types';
import { gridEditorStateOperations } from './gridEditorStateOperations';

const gridEditor$ = persistentReducedStream<GridEditorState>(
  'gridEditor$',
  gridEditorStateOperations.getDefaultGridEditorState(
    getFrameIdFromWindowContext(window)
  ),
  reducers
);

export { gridEditor$ };
